import React from 'react';
import { useHistory } from 'react-router-dom';
import { combineClassNames } from '../../../../../../app/functions';
import {
    HOMEPAGE_NAV_ITEM_TAB,
    HOMEPAGE_NAV_ITEM_BUTTON,
    HOMEPAGE_NAV_ITEM_EXPEND_BUTTON,
    HOMEPAGE_DEFAULT_SLIDER_TAB,
} from '../../../../../../constants/homepage-types';
import './index.scss';

const HeaderNavItem = ({
    data,
    onSelect = () => {},
    selectedTab = HOMEPAGE_DEFAULT_SLIDER_TAB,
    onTabSelect = () => {},
    isVisible = true,
}) => {
    const history = useHistory();

    let handleItemClick = () => {};

    switch (data.type) {
        case HOMEPAGE_NAV_ITEM_TAB:
            handleItemClick = () => {
                onSelect(data);
                onTabSelect(data.index);
            };
            break;

        case HOMEPAGE_NAV_ITEM_BUTTON:
        case HOMEPAGE_NAV_ITEM_EXPEND_BUTTON:
            if (data.onClick) {
                handleItemClick = () => {
                    onSelect(data);
                    data.onClick();
                };
            } else if (data.href) {
                handleItemClick = () => {
                    onSelect(data);
                    history.push(data.href);
                };
            }
            break;
    }

    const baseClassName = (isVisible ? 'header-nav-item_visible' : 'header-nav-item_hidden');

    const isSelected = (data.type === HOMEPAGE_NAV_ITEM_TAB && data.index === selectedTab);

    const withDivider = !isVisible && (data.type === HOMEPAGE_NAV_ITEM_TAB);
    const buttonStyle = !isVisible && (data.type === HOMEPAGE_NAV_ITEM_BUTTON);

    const iconElement = (
        <img
            src={data.iconPath}
            alt="Icon"
            className={combineClassNames(
                'nav-item-icon',
                data?.iconDir && `nav-item-icon_${data.iconDir}`,
                data?.iconModifier && `nav-item-icon_${data.iconModifier}`,
            )}
        />
    );

    return (
        <button
            type="button"
            className={combineClassNames(
                baseClassName,
                isSelected && `${baseClassName}_selected`,
                withDivider && `${baseClassName}_with-divider`,
                buttonStyle && `${baseClassName}_button-style`,
            )}
            onClick={handleItemClick}
        >
            {data?.iconPath && data?.iconDir === 'right' && iconElement}
            {data?.title || data?.text}
            {data?.iconPath && data?.iconDir === 'left' && iconElement}
        </button>
    );
};

export default HeaderNavItem;
